import styled from 'styled-components/macro';

const ActiveFilter = styled.button`
  display: flex;
  justify-content: space-around;
  color: #fff;
  white-space: nowrap;
  border-color: transparent;
  background-color: transparent;
`;

export default ActiveFilter;
